import type { JSX } from 'react'

export const UserIcon = (): JSX.Element => (
  <use href='#userIcon' height='100%' width='100%' />
)
